import { APIScope, LocationVarKey } from "@swivl-mono/types";
import { Navigate, useParams } from "react-router-dom";

import { PageLoadingView } from "../../App/Layout/Loading/LoadingView";
import { useHasPermission } from "../../Helpers/Permissions/useHasPermission";
import LocationVarsModel from "../../Models/Variables/LocationVars.Model";

interface Props {
  scopes?: APIScope[];
  requiredOrgVariables?: LocationVarKey[];
  fallbackAddress?: string;
  disableCheckParams?: boolean;
  children: React.ReactNode;
}

export function RouteShowIf(props: Props) {
  const { orgVariables, isLoaded } = LocationVarsModel.useState((s) => s);
  const { scopes, requiredOrgVariables, fallbackAddress, children, disableCheckParams } = props;
  const params = useParams();

  if (!isLoaded && requiredOrgVariables && requiredOrgVariables.length > 0) {
    return <PageLoadingView />;
  }

  let groupId = !disableCheckParams && params["groupId"] ? parseInt(params["groupId"]) : undefined;
  let locationId = !disableCheckParams && params["locationId"] ? parseInt(params["locationId"]) : undefined;
  let hasPermission = true;
  if (scopes && scopes.length > 0) {
    for (let i = 0; i < scopes.length; i++) {
      const hasScopePermission = useHasPermission(scopes[i], groupId, locationId);
      if (!hasScopePermission) {
        console.warn("No permission for scope", scopes[i]);
        hasPermission = false;
        break;
      }
    }
  }
  if (requiredOrgVariables && requiredOrgVariables.length > 0) {
    for (let i = 0; i < requiredOrgVariables.length; i++) {
      const key = requiredOrgVariables[i];
      const orgVar = orgVariables?.[key];
      if (!orgVar || orgVar.value !== "1") {
        console.warn("Missing required org variable", key);
        hasPermission = false;
        break;
      }
    }
  }

  return hasPermission ? children : <Navigate to={fallbackAddress || "/"} />;
}
